import { useCallback, useEffect, useState } from "react";
import { operatorAuthService } from "../services/operatorAuthService";

export interface UseOperatorAuthReturn {
  isOperatorLoggedIn: boolean;
  operatorToken: string | null;
  operatorLogout: () => void;
  checkOperatorAuth: () => boolean;
}

export const useOperatorAuth = (): UseOperatorAuthReturn => {
  const [operatorToken, setOperatorToken] = useState<string | null>(null);
  const [isOperatorLoggedIn, setIsOperatorLoggedIn] = useState(false);

  // 컴포넌트 마운트 시 로컬 스토리지에서 운영자 토큰 확인
  useEffect(() => {
    const token = operatorAuthService.getToken();
    if (token) {
      setOperatorToken(token);
      setIsOperatorLoggedIn(true);
    }
  }, []);

  // 운영자 로그아웃
  const operatorLogout = useCallback(() => {
    operatorAuthService.logout();
    setOperatorToken(null);
    setIsOperatorLoggedIn(false);
  }, []);

  // 운영자 인증 상태 확인
  const checkOperatorAuth = useCallback((): boolean => {
    return operatorAuthService.isAuthenticated();
  }, []);

  return {
    isOperatorLoggedIn,
    operatorToken,
    operatorLogout,
    checkOperatorAuth,
  };
};

